import './../../assets/css/App.css';
import './../../assets/css/layout.css';
import './../../assets/css/global/components.css';
import 'jquery-ui/themes/base/theme.css';
import 'jquery-ui/themes/base/datepicker.css';
import 'jquery-ui/ui/widgets/datepicker';
import React, { Component } from 'react';
import TableView from './tableView';
import GraphView from './graphView';
import HistogramByCountryView from './histogramByCountryView';
import HistogramBySourceView from './histogramBySourceView';
import PageTitle from './../../component/pageTitle'

class Dashboard extends Component {
    constructor() {
        super();
        this.headerProps = {
            headerName: "Sign Up Page"
        };
    }

    render() {
        return (
            <div className="page-content-wrapper">
                <PageTitle pageTitle = {"Sign Up Statistics Page"} ></PageTitle>
                <div className="page-content tabbable-custom column-xs-12">
                    <TableView></TableView>
                    <div className="graph-border-without-left-margin">
                        <HistogramBySourceView></HistogramBySourceView>
                    </div>
                </div>
                <div className="graph-border">
                    <HistogramByCountryView></HistogramByCountryView>
                </div>
                <div className="graph-border">
                    <GraphView></GraphView>
                </div>
            </div>
        );
    }
}

export default Dashboard;
